module.exports = require("@makemydeal/ui-bricks/dist/cox");